import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const VehiclePage = lazy(() => import('@cobliteam/vehicle'));

const routes = [
  {
    exact: true,
    path: Location.VEHICLES,
    team: 'squad-account-experience',
    component: VehiclePage,
  },
  {
    exact: true,
    path: Location.VEHICLES_RUNNING_WITHOUT_DRIVER,
    team: 'squad-account-experience',
    component: VehiclePage,
  },
];

export default routes;
